<bit-dialog #dialog background="default" class="bv-generator-history-dialog">
  <span bitDialogTitle>{{ "passwordHistory" | i18n }}</span>
  <ng-container bitDialogContent>
    @if (hasHistory$ | async) {
      <bit-credential-generator-history [account]="account$ | async" />
    } @else {
      <bit-empty-credential-history style="display: contents" />
    }
  </ng-container>
  <ng-container bitDialogFooter>
    <div class="bv-generator-history-dialog__footer">
      <button
        type="button"
        class="bv-generator-history-dialog__clear-btn"
        bitIconButton="bwi-trash"
        [disabled]="!(hasHistory$ | async)"
        (click)="clear()"
        [label]="'clearHistory' | i18n"
      ></button>
      <button
        bitButton
        type="button"
        buttonType="secondary"
        class="bv-generator-history-dialog__cancel-btn"
        (click)="cancel()"
      >
        {{ "cancel" | i18n }}
      </button>
    </div>
  </ng-container>
</bit-dialog>
